import { assetsPath } from "../../utils";

const baseAssetUrl = assetsPath("phuket-laguna-park-2");

const landingPage = [
  {
    image: `${baseAssetUrl}/images/residence/landing-page/LP2-Exterior-008.jpg`,
  },
  {
    image: `${baseAssetUrl}/images/residence/landing-page/LP2-Exterior-Townhomes-001.jpg`,
  },
  {
    image: `${baseAssetUrl}/images/residence/landing-page/LP2-Exterior-Townhomes-003.jpg`,
  },
  {
    image: `${baseAssetUrl}/images/residence/landing-page/LP2-Exterior-Villas-004.jpg`,
  },
  {
    image: `${baseAssetUrl}/images/residence/landing-page/LP2-Exterior-Villas-007.jpg`,
  },
];

const type = [
  {
    name: "Townhomes",
    thumbnail: [
      {
        image: `${baseAssetUrl}/images/residence/thumbnail/Townhomes-Thumbnail.jpg`,
      },
      {
        image: `${baseAssetUrl}/images/residence/thumbnail/Townhomes-Thumbnail.jpg`,
      },
    ],
    buttons: [
      {
        type: "description",
        value: 0,
        name: "Description",
        title: "Description",
        description: {
          en:
            "<p>The three-storey townhomes at Laguna Park offer on average 220 sqm of space to live, work, play, and gather. Townhomes come with two or three bedrooms.</p>",
          cn:
            "<p>乐古浪熙园的三层联排别墅 平均面积220平方米，适合 休息、工作、玩乐和聚会。 联排别墅提供了两间或三间 卧室。</p>",
          ru:
            "<p>Жилая площадь трехэтажных таунхаусов, расположенных в комплексе Laguna Park, составляет 220 кв. м. Это предоставляет множество возможностей для отдыха, работы, игр и встреч. Таунхаусы включают в себя две или три спальни.</p>",
        },
        images: [
          {
            image: `${baseAssetUrl}/images/residence/description/townhome/LP2-Exterior-Townhomes-001.jpg`,
          },
          {
            image: `${baseAssetUrl}/images/residence/description/townhome/LP2-Exterior-Townhomes-002.jpg`,
          },
          {
            image: `${baseAssetUrl}/images/residence/description/townhome/LP2-Exterior-Townhomes-003.jpg`,
          },
          {
            image: `${baseAssetUrl}/images/residence/description/townhome/LP2-Interior-Townhomes Bedroom-001.jpg`,
          },
          {
            image: `${baseAssetUrl}/images/residence/description/townhome/LP2-Interior-Townhomes Living room-002.jpg`,
          },
        ],
      },
      {
        type: "plan",
        name: "Ground Floor (Standard)",
        value: 1,
        floorPlan: {
          en: `${baseAssetUrl}/images/residence/floor-plan/townhome/en/sg.png`,
          ru: `${baseAssetUrl}/images/residence/floor-plan/townhome/ru/sg.png`,
          cn: `${baseAssetUrl}/images/residence/floor-plan/townhome/cn/sg.png`,
        },
        images: [
          {
            image: `${baseAssetUrl}/images/residence/floor-plan/townhome/ground-floor-(standard).jpg`,
          },
        ],
        image360: [
          {
            x: 950,
            y: 500,
          },
        ],
        imageVirtual: [
          {
            x: 1000,
            y: 640,
            path: `${baseAssetUrl}/360/townhome/LP2-ST-TH-Living.html`,
          },
        ],
      },
      {
        type: "plan",
        name: "Ground Floor (Deluxe – Upgrade)",
        value: 2,
        floorPlan: {
          en: `${baseAssetUrl}/images/residence/floor-plan/townhome/en/dg.png`,
          ru: `${baseAssetUrl}/images/residence/floor-plan/townhome/ru/dg.png`,
          cn: `${baseAssetUrl}/images/residence/floor-plan/townhome/cn/dg.png`,
        },
        images: [
          {
            image: `${baseAssetUrl}/images/residence/floor-plan/townhome/ground-floor-(deluxe-upgrade).jpg`,
          },
        ],
        image360: [
          {
            x: 950,
            y: 460,
          },
        ],
        imageVirtual: [
          {
            x: 980,
            y: 600,
            path: `${baseAssetUrl}/360/townhome/LP2-DLX-TH-PL.html`,
          },
        ],
      },
      {
        type: "plan",
        name: "1 st Floor",
        value: 3,
        floorPlan: {
          en: `${baseAssetUrl}/images/residence/floor-plan/townhome/en/s1.png`,
          ru: `${baseAssetUrl}/images/residence/floor-plan/townhome/ru/s1.png`,
          cn: `${baseAssetUrl}/images/residence/floor-plan/townhome/cn/s1.png`,
        },
        images: [
          {
            image: `${baseAssetUrl}/images/residence/floor-plan/townhome/1-floor-(standard).jpg`,
          },
        ],
        image360: [
          {
            x: 1030,
            y: 700,
          },
        ],
        imageVirtual: [
          {
            x: 950,
            y: 700,
            path: `${baseAssetUrl}/360/townhome/LP2-ST-TH-MB.html`,
          },
        ],
      },
      {
        type: "plan",
        name: "2 nd Floor (Standard)",
        value: 4,
        floorPlan: {
          en: `${baseAssetUrl}/images/residence/floor-plan/townhome/en/s2.png`,
          ru: `${baseAssetUrl}/images/residence/floor-plan/townhome/ru/s2.png`,
          cn: `${baseAssetUrl}/images/residence/floor-plan/townhome/cn/s2.png`,
        },
        images: [],
        image360: [],
        imageVirtual: [
          {
            x: 990,
            y: 610,
            path: `${baseAssetUrl}/360/townhome/LP2-ST-TH-RF.html`,
          },
        ],
      },
      {
        type: "plan",
        name: "2 nd Floor (Deluxe – Upgrade)",
        value: 5,
        floorPlan: {
          en: `${baseAssetUrl}/images/residence/floor-plan/townhome/en/d2.png`,
          ru: `${baseAssetUrl}/images/residence/floor-plan/townhome/ru/d2.png`,
          cn: `${baseAssetUrl}/images/residence/floor-plan/townhome/cn/d2.png`,
        },
        images: [],
        image360: [],
        imageVirtual: [
          {
            x: 1030,
            y: 570,
            // y: 520,
            path: `${baseAssetUrl}/360/townhome/LP2-DLX-TH-MPR.html`,
          },
        ],
      },
    ],
  },
  {
    name: "Villas",
    thumbnail: [
      {
        image: `${baseAssetUrl}/images/residence/thumbnail/Villa Thumbnail.jpg`,
      },
      {
        image: `${baseAssetUrl}/images/residence/thumbnail/Villa Thumbnail.jpg`,
      },
    ],
    buttons: [
      {
        type: "description",
        value: 0,
        name: "Description",
        title: "Description",
        description: {
          en:
            "<p>Offering generous and practical spaces for larger families, the three-storey villas sit on larger land plots averaging 375 sqm in size. Villas come with three to five bedrooms, as well as multiple living spaces and maid’s quarters with a separate entrance.</p>",
          cn:
            "<p>乐古浪熙园的三层独栋别墅 空间更加宽敞实用，平均面 积375平方米，适合更大的家 庭。独栋别墅提供了三间至 五间卧室，此外还包括多功 能起居空间和一间拥有单独 入口的保姆房。</p>",
          ru:
            "<p>Трехэтажные виллы отличаются исключительной просторностью и практичностью, необходимые большим семьям. Площадь прилегающего участка в среднем составляет 375 кв.м. Виллы включают в себя три- пять спален, множество жилых помещений и помещение для прислуги с отдельным входом.</p>",
        },
        images: [
          {
            image: `${baseAssetUrl}/images/residence/description/villa/LP2-Exterior-Villas-004.jpg`,
          },
          {
            image: `${baseAssetUrl}/images/residence/description/villa/LP2-Exterior-Villas-006.jpg`,
          },
          {
            image: `${baseAssetUrl}/images/residence/description/villa/	LP2-Exterior-Villas-007.jpg`,
          },
          {
            image: `${baseAssetUrl}/images/residence/description/villa/LP2-Interior-Villas Bedroom-003.jpg`,
          },
          {
            image: `${baseAssetUrl}/images/residence/description/villa/LP2-Interior-Villas Living room-004.jpg`,
          },
        ],
      },
      {
        type: "plan",
        name: "Ground Floor (Standard)",
        value: 1,
        floorPlan: {
          en: `${baseAssetUrl}/images/residence/floor-plan/villa/en/sg.png`,
          ru: `${baseAssetUrl}/images/residence/floor-plan/villa/ru/sg.png`,
          cn: `${baseAssetUrl}/images/residence/floor-plan/villa/cn/sg.png`,
        },
        images: [
          {
            image: `${baseAssetUrl}/images/residence/floor-plan/villa/ground-floor-(standard).jpg`,
          },
        ],
        image360: [
          {
            x: 950,
            y: 500,
          },
        ],
        imageVirtual: [
          {
            x: 1020,
            y: 400,
            path: `${baseAssetUrl}/360/villa/LP2-ST-VL-LIV.html`,
          },
          {
            x: 840,
            y: 720,
            path: `${baseAssetUrl}/360/villa/LP2-ST-VL-BR.html`,
          },
        ],
      },
      {
        type: "plan",
        name: "Ground Floor (Deluxe – Upgrade)",
        value: 2,
        floorPlan: {
          en: `${baseAssetUrl}/images/residence/floor-plan/villa/en/dg.png`,
          ru: `${baseAssetUrl}/images/residence/floor-plan/villa/ru/dg.png`,
          cn: `${baseAssetUrl}/images/residence/floor-plan/villa/cn/dg.png`,
        },
        images: [
          {
            image: `${baseAssetUrl}/images/residence/floor-plan/villa/ground-floor-(deluxe-upgrade).jpg`,
          },
        ],
        image360: [
          {
            x: 950,
            y: 420,
          },
        ],
        imageVirtual: [
          {
            x: 920,
            y: 730,
            path: `${baseAssetUrl}/360/villa/LP2-DLX-VL-PL.html`,
          },
        ],
      },
      {
        type: "plan",
        name: "1 st Floor",
        value: 3,
        floorPlan: {
          en: `${baseAssetUrl}/images/residence/floor-plan/villa/en/s1.png`,
          ru: `${baseAssetUrl}/images/residence/floor-plan/villa/ru/s1.png`,
          cn: `${baseAssetUrl}/images/residence/floor-plan/villa/cn/s1.png`,
        },
        images: [
          {
            image: `${baseAssetUrl}/images/residence/floor-plan/villa/1-floor-(standard).jpg`,
          },
        ],
        image360: [
          {
            x: 930,
            y: 700,
          },
        ],
        imageVirtual: [
          {
            x: 850,
            y: 720,
            path: `${baseAssetUrl}/360/villa/LP2-DLX-VL-MBR.html`,
          },
          {
            x: 1000,
            y: 540,
            path: `${baseAssetUrl}/360/villa/LP2-DLX-VL-FM.html`,
          },
        ],
      },
      {
        type: "plan",
        name: "2 nd Floor (Standard)",
        value: 4,
        floorPlan: {
          en: `${baseAssetUrl}/images/residence/floor-plan/villa/en/s2.png`,
          ru: `${baseAssetUrl}/images/residence/floor-plan/villa/ru/s2.png`,
          cn: `${baseAssetUrl}/images/residence/floor-plan/villa/cn/s2.png`,
        },
        images: [],
        image360: [],
        imageVirtual: [
          {
            x: 930,
            y: 670,
            path: `${baseAssetUrl}/360/villa/LP2-ST-VL-RF.html`,
          },
        ],
      },
      {
        type: "plan",
        name: "2 nd Floor (Deluxe – Upgrade)",
        value: 5,
        floorPlan: {
          en: `${baseAssetUrl}/images/residence/floor-plan/villa/en/d2.png`,
          ru: `${baseAssetUrl}/images/residence/floor-plan/villa/ru/d2.png`,
          cn: `${baseAssetUrl}/images/residence/floor-plan/villa/cn/d2.png`,
        },
        images: [],
        image360: [],
        imageVirtual: [
          {
            x: 1000,
            y: 560,
            path: `${baseAssetUrl}/360/villa/LP2-DLX-VL-MPR.html`,
          },
        ],
      },
    ],
  },
];

export default {
  landingPage,
  type,
};



// WEBPACK FOOTER //
// ./src/data/PhuketLagunaPark2/residence.js